import { createContext } from "react";
import { MileageTheme } from "./MileageTheme";

interface ThemeContextType {
  theme: "light" | "dark";
  toggleTheme: () => void;
  mileageTheme: MileageTheme;
  opacity: number;
  setOpacity: (opacity: number) => void;
}

export const ThemeContext = createContext<ThemeContextType | null>(null);
